import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
    IAttributeConfData,
    IAttributeConfDataOption
} from '@df/catalog-ui/product/configurable-options/product-configurable-options.component.def';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import { BoxComponent } from 'projects/app-default/src/app/ui/display/box/box.component';
import { ProductConfigurableOptionsComponent } from './product-configurable-options.component';
@Component({
    selector: 'lp-product-configurable-options',
    templateUrl: './lp-product-configurable-options.html',
    standalone: true,
    imports: [AttributeLabelPipe, BoxComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LpProductConfigurableOptionsComponent extends ProductConfigurableOptionsComponent {
    @Input()
    color: number | undefined;
    override ngOnInit() {
        super.ngOnInit();
        this.onDataChange(false, true);
    }
    override onDataChange(force = false, setFirstSalable = false) {
        if (this.attributes.find(i => i.code === 'color')) {
            this.data['color'] = this.color;
        }
        if (setFirstSalable) {
            const salableLineOptions = this.lineOptions.filter(option => option.salable);
            if (salableLineOptions?.length === 1) {
                this.pick(this.lineAttribute, salableLineOptions[0]);
            }
        }
        super.onDataChange(force);
    }
    /**
     * Options to present (we only support one attribute in this component!)
     */
    get lineOptions(): IAttributeConfDataOption[] | undefined {
        return this.lineAttribute?.options;
    }
    get lineAttribute(): IAttributeConfData | undefined {
        return this.attributes.find(i => i.code === 'size');
    }
    get selection(): IAttributeConfDataOption | undefined {
        return this.lineOptions?.find(i => this.isPicked(this.lineAttribute, i));
    }
}
